import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import BreadcrumbActions from '../Redux/BreadcrumbRedux'
import config from '../Config/AppConfig'

export class EpReportPage extends Component {


  redirectToEp(loggedIn, token) {
    if (!loggedIn) {
      console.info('EP redirect skipped: user is not logged in.')
      return
    }

    const url = config.api.epUrl
    const targetUrl = new URL(url, window.location.href)
    const targetOrigin = targetUrl.origin
    const receiverWindow = window.open(url, '_blank')

    console.info('EP window open handle available:', Boolean(receiverWindow))

    if (!receiverWindow) {
      console.warn('EP window handle is not available. The tab may still open depending on browser policy.')
      console.info('EP token was not sent because no window handle was returned.')
      return
    }

    const payload = {
      type: 'GetAccessToken',
      accessToken: token,
    }

    let attempt = 0
    const maxRetries = 10

    const sendMessage = () => {
      attempt += 1
      try {
        receiverWindow.postMessage(payload, targetOrigin)
      }
      catch (error) {
        console.error(`EP postMessage attempt ${attempt} failed`, error)
      }

      if (attempt < maxRetries && !receiverWindow.closed) {
        setTimeout(sendMessage, 500)
      }
    }

    setTimeout(sendMessage, 500)
    this.props.history.goBack()
  }

  componentDidMount() {
    const { token, loggedIn } = this.props
    this.redirectToEp(loggedIn, token)
  }

  render() {
    return (
      <div />
    )
  }
}

EpReportPage.propTypes = {
  loggedIn: PropTypes.bool,
  token: PropTypes.string
}

EpReportPage.defaultProps = {
  loggedIn: false,
  token: ''
}

const mapDispatchToProps = (dispatch) => {
  return {
    setBreadcrumb: (items) => dispatch(BreadcrumbActions.breadcrumbSetItems(items))
  }
}

const mapStateToProps = state => {
  return {
    loggedIn: state.login.loggedIn,
    token: state.login.accessToken
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EpReportPage)